// next-i18next.config.js
module.exports = {
	i18n: {
		defaultLocale: 'de',
		locales: ['en', 'de'],
		localeDetection: false
		// domains: [
		//   {
		//     domain: 'localhost',
		//     defaultLocale: 'de',
		//     http: true
		//   }
		// ]
	}
};
